module.exports = __webpack_public_path__ + "static/media/unselected_marker_beach.23618546.svg";